'use client';

import {useNavigationStateContext} from '@/context/NavigationProvider';
import {Menu, X} from 'lucide-react';

export default function NavigationMenuToggle() {
  const {isNavOpen, toggleNav} = useNavigationStateContext();

  if (isNavOpen) {
    return <X onClick={toggleNav} />;
  }

  return <Menu onClick={toggleNav} />;
}
